export default {
	debug: false,
};
